import React, {useContext, useEffect, useState} from 'react';
import {Modal} from "../../../../../components/modal/modal.jsx";
import {useLoaderData} from "react-router";
import {BoShowContext} from "../context/bo-show-context.jsx";
import InputCheckbox from "../../../../../components/input/input-checkbox.jsx";
import moment from "moment";
import Button from "../../../../../components/button/button.jsx";

const BoShowVersionModal = ({open, setOpen}) => {
    const {dataFetch, syncId, setAttributesByData, setAttributesBySync, offsetUTC} = useContext(BoShowContext);

    const loaderData = useLoaderData();
    const [tempSyncId, setTempSyncId] = useState(undefined);

    useEffect(() => {
        setTempSyncId(syncId);
    }, [syncId]);

    const boGcmItems = dataFetch?.bogcm
    const boGcm = boGcmItems?.bogcm;
    const boSyncs = dataFetch?.syncs;

    const loadVersion = () => {
        if (tempSyncId) {
            const index = boSyncs.findIndex(sync => sync.id === tempSyncId);
            setAttributesBySync(index);
        } else {
            setAttributesByData()
        }

        setOpen(false);
    }

    return (
        <Modal open={open} setOpen={setOpen} title={`Versões do ${loaderData?.bo_name}`} className={"w-6/12"} overflow={true}>
            <Modal.Body className={"space-y-2 overflow-auto max-h-[calc(100vh-230px)]"}>
                {
                    boGcm?.data &&
                    <>
                        <p className={"font-bold"}>Versão enviada - última alteração</p>
                        <InputCheckbox
                            id={"lastEdit"}
                            label={boGcmItems?.lastEditDate + " - " + boGcmItems.lastEditUserName}
                            checked={!tempSyncId}
                            onChange={() => setTempSyncId(undefined)}
                        />
                    </>
                }

                {
                    boSyncs && boSyncs.length > 0 &&
                    <>
                        <p className={"font-bold"}>Versões não enviadas</p>
                        {
                            boSyncs.map((sync, index) => {
                                const dtLastSync = moment.utc(sync.dtLastSync).utcOffset(offsetUTC).format('DD/MM/YYYY HH:mm');

                                return (
                                    <InputCheckbox
                                        key={"sync-" + index}
                                        id={"sync-" + index}
                                        label={<>{dtLastSync} - {sync.userName} {!sync.fullySynced && <span className={"text-[#ff5353] italic"}>Sincronização incompleta</span>}</>}
                                        checked={tempSyncId === sync.id}
                                        onChange={() => setTempSyncId(sync.id)}
                                    />
                                )
                            })
                        }
                    </>
                }
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={loadVersion}>
                    Carregar
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default BoShowVersionModal;